/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface VisitPaymentMarkingListItemDto
 */
export interface VisitPaymentMarkingListItemDto {
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'appointedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'currentPaymentMarking': VisitPaymentMarkingListItemDtoCurrentPaymentMarkingEnum;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'grossPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'insertionTime': string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'medicalService'?: VisitPaymentMarkingListItemDtoMedicalServiceEnum;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'patientName': string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'paymentReceivedMarkedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'paymentReceivedMarkedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'timeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'visitStatus'?: VisitPaymentMarkingListItemDtoVisitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'visitType'?: VisitPaymentMarkingListItemDtoVisitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'waitingForPaymentMarkedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitPaymentMarkingListItemDto
     */
    'waitingForPaymentMarkedBy'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum VisitPaymentMarkingListItemDtoCurrentPaymentMarkingEnum {
    WaitingForPayment = 'WAITING_FOR_PAYMENT',
    PaymentReceived = 'PAYMENT_RECEIVED'
}
/**
    * @export
    * @enum {string}
    */
export enum VisitPaymentMarkingListItemDtoMedicalServiceEnum {
    Visit0 = 'VISIT_0',
    Visit1 = 'VISIT_1',
    StandardVisit = 'STANDARD_VISIT',
    StandardVisit15 = 'STANDARD_VISIT_15',
    FollowupVisit = 'FOLLOWUP_VISIT',
    Message = 'MESSAGE',
    Prescription = 'PRESCRIPTION',
    AbsentConsultation = 'ABSENT_CONSULTATION',
    NeurosurgeonConsultation = 'NEUROSURGEON_CONSULTATION',
    NeuropsychologistConsultation = 'NEUROPSYCHOLOGIST_CONSULTATION',
    NeurologopedistConsultation = 'NEUROLOGOPEDIST_CONSULTATION',
    PsychiatristConsultation = 'PSYCHIATRIST_CONSULTATION',
    GeneticistConsultation = 'GENETICIST_CONSULTATION',
    EpileptologistConsultation = 'EPILEPTOLOGIST_CONSULTATION',
    NeurologistConsultation = 'NEUROLOGIST_CONSULTATION',
    DieticianConsultation = 'DIETICIAN_CONSULTATION',
    VnsConsultation = 'VNS_CONSULTATION',
    MetabolicConsultation = 'METABOLIC_CONSULTATION',
    SleepDisturbanceConsultation = 'SLEEP_DISTURBANCE_CONSULTATION',
    CaseConference = 'CASE_CONFERENCE',
    AdhdConsultation = 'ADHD_CONSULTATION',
    PsychotherapyConsultation = 'PSYCHOTHERAPY_CONSULTATION',
    TmsQualificationConsultation = 'TMS_QUALIFICATION_CONSULTATION',
    TmsInductionConsultation = 'TMS_INDUCTION_CONSULTATION',
    Tms15MConsultation = 'TMS_15M_CONSULTATION',
    Tms30MConsultation = 'TMS_30M_CONSULTATION',
    Tms45MConsultation = 'TMS_45M_CONSULTATION',
    EegConsultation = 'EEG_CONSULTATION',
    VeegNightConsultation = 'VEEG_NIGHT_CONSULTATION',
    VeegDayConsultation = 'VEEG_DAY_CONSULTATION',
    VeegOnStandbyConsultation1H = 'VEEG_ON_STANDBY_CONSULTATION_1H',
    VeegOnStandbyConsultation2H = 'VEEG_ON_STANDBY_CONSULTATION_2H',
    VeegOnStandbyConsultation6H = 'VEEG_ON_STANDBY_CONSULTATION_6H',
    VeegDuringSleepConsultation1H = 'VEEG_DURING_SLEEP_CONSULTATION_1H',
    VeegDuringSleepConsultation2H = 'VEEG_DURING_SLEEP_CONSULTATION_2H',
    VeegDuringSleepConsultation6H = 'VEEG_DURING_SLEEP_CONSULTATION_6H',
    MigrationVisit = 'MIGRATION_VISIT',
    VeegOnStandbyConsultation = 'VEEG_ON_STANDBY_CONSULTATION',
    VeegDuringSleepConsultation = 'VEEG_DURING_SLEEP_CONSULTATION',
    PartnerConsultation = 'PARTNER_CONSULTATION'
}
/**
    * @export
    * @enum {string}
    */
export enum VisitPaymentMarkingListItemDtoVisitStatusEnum {
    Done = 'DONE',
    Cancelled = 'CANCELLED',
    Additional = 'ADDITIONAL',
    ToMove = 'TO_MOVE'
}
/**
    * @export
    * @enum {string}
    */
export enum VisitPaymentMarkingListItemDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


